<template style="height:100%">
  <div class="Module_management">
    <div class="Module_management_top">
      <h2>模块管理</h2>

      <el-form :inline="true" :model="formInline" class="demo-form-inline">

        <el-form-item label="栏目名称:">
          <el-input v-model="formInline.itemName" placeholder="审批人"></el-input>
        </el-form-item>

        <el-form-item label="创建者:">
          <el-date-picker v-model="formInline.creator" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="创建时间:">
          <el-date-picker v-model="formInline.createTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-button type="primary" @click="inquire()">查询</el-button>
        <el-button type="primary" @click="chongzhi()">重置</el-button>


      </el-form>
    </div>


    <div class="Module_management_nav">
      <div class="Module_management_nav_top">
        <el-button type="primary" @click="addfun()">新增</el-button>
        <el-button type="primary" @click="qiyong('1')">启用</el-button>
        <el-button type="primary" @click="shanchu()">删除</el-button>
        <el-button type="primary" @click="qiyong('0')">关闭</el-button>
      </div>

      <div class="talies">

        <el-table ref="multipleTable" v-loading="wloadings" @selection-change="handleSelectionChange" :row-key="(row) => {return row.itemKey }" :data="tableData" style="width: 98%; margin-top: 10px;margin-left: 1%;" :default-sort="{ prop: 'date', order: 'descending' }">

          <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="栏目名称">
            <template slot-scope="scope">
              <span>{{ scope.row.itemName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="简介">
            <template slot-scope="scope">
              <span>{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建者">
            <template slot-scope="scope">
              <span>{{ scope.row.creator }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1">启用</span>
              <span v-else-if="scope.row.status == 0">关闭</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作">
            <template slot-scope="scope">
              <el-button @click="looks(scope.row)" type="text" size="small">
                修改
              </el-button>
              <!-- <el-button @click="pinglunfanxie(pinglunfanxienum, scope.row.ContentNo)" type="text" size="small">
                编辑
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData.length > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="text1" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="模块名称" prop="ContentName">
          <el-input v-model="ruleForm.ContentName" placeholder="请输入模块名称"></el-input>
        </el-form-item>
        <el-form-item label="内容简介" prop="Remark">
          <el-input v-model="ruleForm.Remark" placeholder="请输入内容简介"></el-input>
        </el-form-item>
        <el-form-item label="模块封面" prop="region">
          <div class="cover" style="margin-left:-70px">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/gif,image/png">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择封面</span>
              </i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">{{ text2 }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="帖子详情" :visible.sync="dialogVisiblelook" width="70%" :before-close="handleClose">
      <div class="post_details_top">
        <img :src="xiangsvc.Cover" alt="">
        <div class="post_details_top_right">
          <h3>{{ xiangsvc.ContentName }}</h3>
          <p>内容</p>
          <ul>
            <li>
              <el-switch v-model="pinglun" disabled inactive-text="允许评论">
              </el-switch>
            </li>
            <li>
              <span>帖子分类：{{ xiangsvc.ItemName }}</span>
            </li>
            <li>
              <span>浏览量：{{ xiangsvc.ContentLike }}</span>
            </li>
            <li>
              <span>点赞数：{{ xiangsvc.Status }}</span>
            </li>
            <li>
              <span>关注数：{{ xiangsvc.Search }}</span>
            </li>
            <li>
              <span>转发量：{{ xiangsvc.Share }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="post_details_buttom">
        <h3>用户评论</h3>
        <ul ref="box" v-infinite-scroll="load" style="overflow:auto">

          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>

          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>

          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>

          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>
          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>
          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>
          <li>
            <div class="post_details_buttom_top">
              <img src="../../assets/16logo.jpg" alt="">
              <span>小明</span>
              <p>评论类容</p>
              <i>2020-01-15-11：10</i>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      itemKeys:'',
      text1:'新增',
      text2: '立即创建',
      xiangsvc: [],//详情反写
      pinglunfanxienum: 1,
      itemKey: [],
      pinglun: true,
      duotupian: [],//多图片
      fengmian: "",//封面
      shipin: '',
      fileList: [],
      imageUrl: "",
      dialogVisible: false,
      dialogVisiblelook: false,
      wloadings: true,
      tableData: [],
      currentPage1: 1,
      ruleForm: {
        ContentName: '',//主题
        Remark: '',//简介
        ItemName: '',//帖子栏目名称
        Status: '0',//是否直接启用
        ItemNo: Date.now(),//帖子栏目编号
        Cover: '',//帖子封面
        ShiMaterialPath: '',//视频
        Files: [],//图片
      },

      pageIndexs: 1,
      formInline: {
        itemName: '',
        creator: '',
        createTime: "",
        pageSize: '10',
        pageIndex: '1',
      },

      lookren: '',
      chuanren: '',
      vdoi: '',
      approverdata: [],
      rendata: '',
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [],
      activeNames: ['1'],
      options: [],
      timedata: [],
      EventNo: Date.now(),
      dialogVisibles: false,
      props: { multiple: true },
      dialogVisible: false,
      ContinueType: false,
      Intervaldays: false,
      xaxcs: false,
      AsxL: false,
      rules: {
        ContentName: [
          { required: true, message: '请输入模块名称', trigger: 'blur' },
        ],
        Remark: [
          { required: true, message: '请输入内容简介', trigger: 'blur' }
        ]
      }
    };
  },
  components: {

  },
  methods: {
    looks(row) {
      this.itemKeys = row.itemKey;
      var from = {itemKey: row.itemKey}
      this.$Http_Post("/activitymanagement/fxitem", { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dialogVisible = true;
          this.text1 = '修改';
          this.text2 = '立即修改';
          this.ruleForm.ContentName = res.Data.itemName;
          this.ruleForm.Remark = res.Data.remark;
          this.imageUrl = res.Data.cover;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    shanchu() {
      if (this.itemKey.length > 0) {
        var from = { "itemKeys": this.itemKey, }
        this.$Http_Post("/activitymanagement/deitem", { from: from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.itemKey = [];
            this.loading();
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      } else {
        this.Global.request_failure("请选择帖子");
      }
    },
    qiyong(val) {
      if (this.itemKey.length > 0) {
        var from = { "itemKeys": this.itemKey, "status": val}
        this.$Http_Post("/activitymanagement/qgitem", { from: from }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.$refs.multipleTable.clearSelection();
            this.loading();
            this.itemKey = [];
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      } else {
        this.Global.request_failure("请选择帖子");
      }
    },
    load() {
      alert("到底加载")
    },

    handleRemove(file, fileList) {//多图片

    },
    handlePreview(file) {//多图片
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 8
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleClose(done) {
      this.$confirm('确认关闭？').then(_ => {
        done();
      })
      .catch(_ => {});
    },
    checkSelectable(row, index) {
      if (row.IsSubmit == "已生成报告") {
        return true;
      } else {
        return true;
      }
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.loading();
    },
    getPartnerName(row, col) {

    },

    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].itemKey);
      }
      this.itemKey = lsc;
    },
    toren(val, v, s) {
      this.lookren = val.Name;
      this.chuanren = val.UserID;
      this.ruleForm.spUserID = val.UserID;
      this.vdoi = s;
      this.ruleForm.spRoleID = v;
    },
    handleChange(file,fileList) {
      if (file.raw.type == "image/jpeg" || file.raw.type == "image/gif" || file.raw.type == "image/png") {
        this.imageUrl = URL.createObjectURL(file.raw);
        this.ruleForm.Cover = file;
      } else {
        this.$message({type: 'error',message: "文件格式错误，请上传图片"})
      }
    },
    ccslkj() {
      this.timedata.push(this.ruleForm.EventTime);
    },
    bfds(val) {
      this.timedata.splice(val, 1);
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    UploadUrl: function () {
      //因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    addfun() {
      this.dialogVisible = true
      this.text1 = '新增'
      this.text2 = '立即创建'
      this.ruleForm.ContentName = '';
      this.ruleForm.Remark = '';
      this.ruleForm.Cover = '';
      this.imageUrl = '';
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.iscontinuous = true
          if (this.text2 == '立即创建') {
            var from = new FormData();
            from.append('itemName', this.ruleForm.ContentName);
            from.append('remark', this.ruleForm.Remark);
            from.append('fbCover', this.ruleForm.Cover.raw);
            this.$Http_Post('/activitymanagement/additem', from, { 'Content-Type': 'multipart/form-data' }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.Global.request_successful(res.Message);
                this.loading();
                this.dialogVisible = false;
                this.ruleForm.ContentName = '';
                this.ruleForm.Remark = '';
                this.ruleForm.Cover = '';
                this.imageUrl = '';
              } else {
                this.iscontinuous = false
                this.Global.request_failure(res.Message);
              }
            })
          } else if (this.text2 == '立即修改') {
            var from = new FormData();
            from.append('itemKey', this.itemKeys);
            from.append('itemName', this.ruleForm.ContentName);
            from.append('remark', this.ruleForm.Remark);
            from.append('fbCover', this.ruleForm.Cover.raw);
            this.$Http_Post('/activitymanagement/upitem', from, { 'Content-Type': 'multipart/form-data' }).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.Global.request_successful(res.Message);
                this.dialogVisible = false;
                this.ruleForm.ContentName = '';
                this.ruleForm.Remark = '';
                this.ruleForm.Cover = '';
                this.imageUrl = '';
              } else {
                this.iscontinuous = false
                this.Global.request_failure(res.Message);
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    pinglunfanxie(num, ContentNo) {
      this.dialogVisiblelook = true;
      var from = {"pageSize": "10","pageIndex": num,"ContentNo": ContentNo,}
      this.$Http_Post("ActivityManagement/GetContentXq",{from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xiangsvc = res.Data;
        }
      })
    },
    inquire() {
      this.formInline.pageIndex = 1;
      this.loading();
    },
    chongzhi(){
      this.formInline.pageIndex = 1;
      this.formInline.itemName = ''
      this.formInline.creator= ''
      this.formInline.createTime= ''
      this.loading();
    },
    loading() {
      var from = {itemName: this.formInline.itemName,creator: this.formInline.creator,SubjectTime: this.formInline.SubjectTime,pageSize: this.formInline.pageSize,pageIndex: this.formInline.pageIndex}
      this.$Http_Post("/activitymanagement/getitems",{from: from}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.Counts = Number(res.Counts);
          this.wloadings = false;
        } else {
          this.wloadings = false;
        }
      })
    },
    lazyLoading(e) {
 
    }
  },
  mounted() {
    this.loading(1, 0);
  }
};
</script>
<style>
.Module_management{height: 100%;}
.Module_management .Module_management_top {height: 152px;width: 100%;background-color: #fff;}
.Module_management .Module_management_top .el-form {margin-left: 20px;}
.Module_management .Module_management_top h2 {width: 98%;height: 50px;line-height: 50px;margin-left: 16px;font-size: 18px;}
.Module_management .demo-form-inline .el-form-item__content {width: 70%;}
.Module_management .Module_management_top .Module_management_div {height: 30px;margin-top: 16px;}
.Module_management .Module_management_top .Module_management_div span {width: 80px;margin-left: 16px;float: left;}
.Module_management .Module_management_top .Module_management_div ul {display: inline-block;float: left;margin-left: -20px;}
.Module_management .Module_management_top .Module_management_div li {float: left;margin-left: 20px;}
.Module_management_nav {background-color: #fff;margin-top: 16px;height: calc(100% - 170px);}
.Module_management .Module_management_nav_top {padding-top: 16px;margin-left: 16px;}
.Module_management .el-form-item__content {width: 50%;}
.Module_management .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
.Module_management .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;margin-left: 0px;overflow: hidden;}
.Module_management .avatar-uploader .el-upload:hover {border-color: #409eff;}
.Module_management .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.post_details_top {height: 100px;border-bottom: 1px solid #d6d6d6;}
.post_details_top img {width: 120px;height: 80px;float: left;}
.Module_management .el-dialog__body {padding-top: 0px;}
.Module_management .post_details_top_right {width: calc(100% - 140px);height: 80px;float: right;}
.Module_management .post_details_top_right h3 {font-size: 14px;}
.Module_management .post_details_top_right p {margin-top: 10px;}
.Module_management .post_details_top_right ul {margin-top: 10px;}
.Module_management .post_details_top_right ul li {float: left;width: calc(100% / 6)}
.Module_management .post_details_buttom {margin-top: 20px;width: 100%;}
.Module_management .post_details_buttom h3 {margin-top: 10px;}
.Module_management .post_details_buttom ul {max-height: 400px;border: 1px solid #d6d6d6;margin-top: 10px;overflow: auto;}
.Module_management .post_details_buttom ul::-webkit-scrollbar {height: 0;width: 0;}
.Module_management .post_details_buttom li {position: relative;height: 80px;margin-top: 20px;}
.Module_management .post_details_buttom_top img {width: 30px;height: 30px;border-radius: 50%;position: absolute;top: 10px;left: 10px;}
.Module_management .post_details_buttom_top span {margin-left: 20px;display: inline-block;position: absolute;top: 14px;left: 40px;font-size: 16px;}
.Module_management .post_details_buttom_top p {position: absolute;top: 44px;left: 60px;color: #000;}
.Module_management .post_details_buttom_top i {position: absolute;top: 66px;left: 60px;}
</style>